// Node.js global polyfills — must be the first module evaluated.
// @react-pdf/renderer uses Buffer internally; CRA 5 no longer auto-polyfills Node globals.
/* global globalThis */
import { Buffer } from 'buffer';
if (typeof globalThis !== 'undefined' && !globalThis.Buffer) {
  globalThis.Buffer = Buffer;
}
